import { render, staticRenderFns } from "./td-securityOpt.vue?vue&type=template&id=bb7d588a&"
import script from "./td-securityOpt.vue?vue&type=script&lang=js&"
export * from "./td-securityOpt.vue?vue&type=script&lang=js&"
import style0 from "./td-securityOpt.vue?vue&type=style&index=0&id=bb7d588a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports